import React from 'react'

import { withRouter } from 'react-router-dom'

import {Dimmer, Header, Icon, Message, Modal } from 'semantic-ui-react';


import './style.css';

import { API } from 'services';

class TokenCancellationScene extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      default: true,
      success: false,
    };
  }

  componentDidMount() {

    let params = new URLSearchParams(window.location.search);

    if(!params.has('token')) {
      this.props.history.push('/');
    }

    this.setState({
      token: params.get('token')
    }, this.handleSubmit({}));

  }

  handleClose() {
    this.props.history.push('/');
  }

  handleSubmit(data) {

    this.setState({
      default: false,
      failure: false
    }, () => {
      // Adding token to data to be sent
      data.token = this.state.token;

      API.post('/users/password/abort', data)
        .then(() => {

          this.setState({
            success: true
          });

        })
        .catch((error) => {
            this.setState({
              failure: true
            });
        });
    })
  }

  render() {

    return (
      <Modal id="token-cancellation" open size='small' dimmer="blurring">
        <Header icon="user" content="Bienvenue sur EquiSym" />
        <Modal.Content className="modal_content">
          {/* <FormWrapper> */}
          <Dimmer.Dimmable blurring dimmed={this.state.success}>
            <Dimmer active={this.state.success} inverted />
            {this.state.failure &&
              <Message error>
                Une erreur est survenue lors du traitement de votre demande
              </Message>
            }
          </Dimmer.Dimmable>
          {/* Success */}
          {this.state.success &&
            <div className="overlay">
              <Icon name="checkmark" size="huge" color="green" />
              <span>Demande annulée</span>
            </div>
          }

        </Modal.Content>
      </Modal>
    );
  }
}

export default withRouter(TokenCancellationScene);